import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DeviceDetailsComponent } from 'libs/portal/src/modules/tools/device-details/device-details.component';
import { AuthGuardService } from 'libs/portal/src/services/auth-guard/auth-guard.service';

import { MikrotikDevicesPageComponent } from './mikrotik-devices.page';

const routes: Routes = [
  {
    path: '',
    // component: LayoutComponent,
    children: [
      {
        component: MikrotikDevicesPageComponent,
        canActivate: [AuthGuardService],
        pathMatch: 'full',
        path: '',
      },
    ],
  },
  {
    path: 'Details',
    data: { breadcrumb: 'Details' },
    canActivate: [AuthGuardService],
    component: DeviceDetailsComponent,
    // loadChildren: () =>
    //   import("../tools/device-details/device-details.module").then(
    //     (m) => m.DeviceDetailsModule
    //   ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MikrotikDevicesPageRoutingModule {}
